import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { callNavigateButton } from "../../../Services/redux";
import {
  CircularProgress,
  Backdrop,
  Box,
  Typography,
  IconButton,
  Modal,
  Button,
  Container,
  Grid2,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  fetchSubmissionDetails,
  postSubmissionDetails,
  putSubmissionDetailsGarageMode,
} from "../../../Services/redux/Application-details/ApplicationDetailsActions";
import { fetchApplicationDetails } from "../../../Services/redux/appId-details/AppIdDeatilsActions";
import { fetchCategoryDetails } from "../../../Services/redux/Category/CategoryActions";
import {
  fetchLanguageDetails,
  fetchCurrentLanguage,
} from "../../../Services/redux/languages-details/LanguageDetailsActions";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Topheader from "../../../Layout/header/header";
import ApplicationDetailsSideMenu from "../../../Components/ApplicationDetailsSideMenu/ApplicationDetailsSideMenu";
import ListingHeader from "../../../Components/ListingHeader/ListingHeader";
import ApplicationDetailsAPKFile from "../../../Components/APKFile/ApplicationDetailsAPKFile";
import AppDetailsLanguage from "../../../Components/ApplicationDetails-Language/AppDetailsLanguage";
import ApplicationDetailsIcon from "../../../Components/ApplicationDetailsIcon/ApplicationDetailsIcon";
import ApplicationDetailsCategory from "../../../Components/ApplicationDetailsCategory/ApplicationDetailsCategory";
import ApplicationDetailsRollout from "../../../Components/ApplicationDetailsRollout/ApplicationDetailsRollout";
import ApplicationDetailsAdditionalDocument from "../../../Components/ApplicationDetailsAdditionalDocument/ApplicationDetailsAdditionalDocument";
import ApplicationDetailsClusterCompatibity from "../../../Components/ApplicationDetailsClusterCompatibity/ApplicationDetailsClusterCompatibity";
import ApplicationDetailsDLCM from "../../../Components/ApplicationDetailsDLCM/ApplicationDetailsDLCM";
import ApplicationDetailsLegalDocuments from "../../../Components/ApplicationDetailsLegalDocuments/ApplicationDetailsLegalDocuments";
import DomainApproverApplicationDetailsTargeting from "../../../Components/domain-approver-application-details-targeting/DomainApproverApplicationDetailsTargeting";
import ApplicationQaReportsPopUp from "../../../Components/ApplicationQaReportsPopUp/ApplicationQaReportsPopUp";
import GlobalAdminMonetize from "../../../Components/Global-Admin-Components/GlobalAdminMonetize/GlobalAdminMonetize";
import ApplicationDetailsDSA from "../../../Components/ApplicationDetailsDSA/ApplicationDetailsDSA";
import ApplicationDetailsFlexMetaData from "../../../Components/ApplicationDetailsFlexMetaData/ApplicationDetailsFlexMetaData";
import ApplicationDetailsAgeRatingAds from "../../../Components/ApplicationDetails-Age-Rating-Ads/ApplicationDetailsAgeRatingAds";
function GlobalAdminApplicationDetails() {
  const globalAdmin_ReadOnly =
    sessionStorage.getItem("readonly_GlobalAdmin") === "true";
  const { appId, submissionId } = useParams();
  const appMultiSubmissionId = submissionId;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const APKfileRef = useRef(null);
  const [submissionDetailsFetched, setSubmissionDetailsFetched] =
    useState(false);
  const [showQAReports, setShowQAReports] = useState([]);
  const [open, setOpen] = useState(false);
  const [openAddReportPopup, setOpenAddReportPopup] = useState(false);
  const [hasError, setHasError] = useState(false);
  const appData = useSelector(
    (state) => state.applicationDetails.applicationDetails
  );
  const { submissionDetails } = useSelector((state) => state.submissionDetails);
  const categoryData = useSelector((state) => state.categoryDetails);
  const languageData = useSelector((state) => state.languageDetails.languages);
  const submissionError = useSelector((state) => state.submissionDetails?.error);
  const appDetailsError = useSelector((state) => state.applicationDetails?.error);

  const postCallTheNewSubmissionGlobalAdmin = (data) => {
    dispatch(putSubmissionDetailsGarageMode(appId, submissionId, data));
  };
  const callNewSubmissionId = (submissionId) => {
    setSubmissionDetailsFetched(false);
    dispatch(fetchSubmissionDetails(appId, submissionId));
  };
  const callPostSubmissionRequest = (status, forceInstall) => {
    dispatch(postSubmissionDetails(appId, submissionId, status, forceInstall));
    navigate(-1);
  };
  useEffect(() => {
    dispatch(fetchCategoryDetails());
    dispatch(fetchLanguageDetails("en-001"));
    return () => {
      dispatch(callNavigateButton());
    };
  }, [dispatch]);

  useEffect(() => {
    if (appId) {
      dispatch(fetchCategoryDetails()).catch((error) => {
        console.error("Error fetching category details:", error);
      });
      dispatch(fetchApplicationDetails(appId)).catch((error) => {
        console.error("Error fetching application details:", error);
        setHasError(true);
        setLoader(false);
      });
    }
  }, [appId, dispatch]);

  useEffect(() => {
    if (!submissionDetailsFetched && appId && submissionId) {
      dispatch(fetchSubmissionDetails(appId, submissionId))
        .catch((error) => {
          console.error("Error fetching submission details:", error);
          setHasError(true);
          setLoader(false);
        });
      setSubmissionDetailsFetched(true);
    }
  }, [appId, submissionId, submissionDetailsFetched, dispatch]);

  useEffect(() => {
    if (submissionDetails?.descriptions?.length > 0) {
      if (sessionStorage.getItem("currentLanguage")) {
        dispatch(
          fetchCurrentLanguage(sessionStorage.getItem("currentLanguage"))
        );
      } else {
        dispatch(fetchCurrentLanguage(submissionDetails.defaultLanguage));
      }
    }
  }, [submissionDetails, dispatch]);

  const backToApplications = () => {
    sessionStorage.removeItem("currentLanguage");
    navigate("/ui/harman-admin/applications");
  };

  useEffect(() => {
    if (submissionError || appDetailsError) {
      setHasError(true);
      setLoader(false);
      return;
    }
    if (
      submissionDetails &&
      Object.keys(submissionDetails).length > 0 &&
      appData &&
      Object.keys(appData).length > 0
    ) {
      setLoader(false);
      setHasError(false);
    }
  }, [submissionDetails, appData, submissionError, appDetailsError]);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  useEffect(() => {
    if (submissionDetails?.reports?.length > 0) {
      const showTwoQAReports = submissionDetails.reports.slice(0, 2);
      if (open) {
        setShowQAReports([]);
      } else {
        setShowQAReports(showTwoQAReports);
      }
    }
  }, [submissionDetails, open]);

  return (
    <>
      <Topheader />
      <Backdrop
        sx={(theme) => ({
          color: "#fff",
          zIndex: theme.zIndex.drawer + 1,
        })}
        open={loader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {!loader && !hasError && (
        <Container maxWidth="lg">
          <Grid2 container>
            <Grid2 size={12}></Grid2>
            <div
              className="container-application-details"
              style={
                submissionDetails.status === "DRAFT"
                  ? {
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                    }
                  : { display: "flex", flexDirection: "row" }
              }
            >
              <div
                className="side-menu"
                style={
                  submissionDetails.status === "DRAFT"
                    ? { marginTop: "0px" }
                    : { marginTop: "69px" }
                }
              >
                <button
                  className="arrow-back"
                  onClick={backToApplications}
                  style={{ background: "none", border: "none", cursor: "pointer", padding: 0 }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <ArrowBackIcon style={{ color: "#717273" }} />
                  </div>
                  <div className="my-apps">My Apps</div>
                </button>
                {submissionDetails &&
                  Object.keys(submissionDetails).length > 0 &&
                  appData &&
                  Object.keys(appData).length > 0 && (
                    <ApplicationDetailsSideMenu
                      appData={appData}
                      appMultiSubmissionId={appMultiSubmissionId}
                      callNewSubmissionId={callNewSubmissionId}
                    />
                  )}
              </div>
              <div
                className="submission-container"
                style={
                  submissionDetails.status === "DRAFT"
                    ? { marginLeft: "0" }
                    : { width: "100%", marginLeft: "13%" }
                }
              >
                <div
                  className="fixed-content-application-details"
                  style={
                    submissionDetails.status === "DRAFT"
                      ? {
                          width: "1160px",
                        }
                      : {
                          width: "1010px",
                        }
                  }
                >
                  <ListingHeader
                    callPostSubmissionRequest={callPostSubmissionRequest}
                  />
                </div>

                <div className="scrollable-content">
                  {/* QA Reports */}
                  {submissionDetails &&
                    submissionDetails.status !== "SUBMITTED_FOR_PRODUCTION" &&
                    submissionDetails.status !== "GENERATING_DELTA" &&
                    submissionDetails.status !== "DELISTED_BY_SELLER" &&
                    submissionDetails.status !== "DELISTED_BY_ADMIN" &&
                    submissionDetails.status !== "DELISTED_BY_APPROVER" && (
                      <Box
                        className="qaReports-section"
                        style={{ marginLeft: "10%" }}
                      >
                        <Box
                          sx={{
                            mx: 2,
                            py: 1.5,
                            display: "flex",
                            justifyContent: "space-between",
                            gap: "2px",
                            alignItems: "center",
                          }}
                        >
                          <div>
                            <Typography
                              sx={{
                                fontWeight: "600",
                                fontSize: "22px",
                              }}
                            >
                              Harman QA Test Results
                            </Typography>
                            <span
                              style={{ fontSize: "16px", fontWeight: "600" }}
                            >
                              Reports
                            </span>
                          </div>
                          <div
                            className="qaReports-right-section"
                            style={{
                              display: "flex",
                              gap: "16px",
                              alignItems: "center",
                            }}
                          >
                            {submissionDetails?.reports?.length > 2 &&
                              !open && (
                                <Typography
                                  sx={{
                                    fontWeight: "500",
                                    fontSize: "14px",
                                    lineHeight: "100%",
                                    letterSpacing: "0%",
                                    color: "#0476E2",
                                    cursor: "pointer",
                                  }}
                                  onClick={handleOpen}
                                >
                                  View More Reports
                                </Typography>
                              )}

                            <div>
                              <Button
                                className="add-more-reports-button"
                                onClick={() => setOpenAddReportPopup(true)}
                                disabled={globalAdmin_ReadOnly}
                                sx={{
                                  opacity: globalAdmin_ReadOnly ? "0.5" : "1",
                                  textTransform: "none",
                                }}
                              >
                                <svg
                                  width="14"
                                  height="15"
                                  viewBox="0 0 14 15"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M6 8.5H0V6.5H6V0.5H8V6.5H14V8.5H8V14.5H6V8.5Z"
                                    fill="#0476E2"
                                  />
                                </svg>
                                Add Report
                              </Button>
                            </div>
                          </div>
                        </Box>

                        <ApplicationQaReportsPopUp
                          qaReports={showQAReports}
                          openAddReportPopup={openAddReportPopup}
                          setOpenAddReportPopup={setOpenAddReportPopup}
                        />
                      </Box>
                    )}

                  {Object.keys(submissionDetails).length > 0 && (
                    <ApplicationDetailsAPKFile
                      ref={APKfileRef}
                      id="apkfile"
                      submissionData={submissionDetails}
                    />
                  )}
                  {languageData.length > 0 &&
                  Object.keys(submissionDetails).length > 0 ? (
                    <AppDetailsLanguage
                      languageData={languageData}
                      submissionData={submissionDetails}
                    />
                  ) : null}

                  {submissionDetails &&
                    Object.keys(submissionDetails).length > 0 && (
                      <ApplicationDetailsIcon
                        submissionData={submissionDetails}
                      />
                    )}
                  <ApplicationDetailsAgeRatingAds/>
                  {sessionStorage.getItem("idpLogin") === "true" && (
                    <ApplicationDetailsClusterCompatibity />
                  )}
                  {submissionDetails && (
                    <ApplicationDetailsFlexMetaData
                      submissionData={submissionDetails}
                    />
                  )}
                  {sessionStorage.getItem("idpLogin") === "true" && (
                    <ApplicationDetailsDLCM />
                  )}
                  <ApplicationDetailsAdditionalDocument
                    submissionData={submissionDetails}
                    appId={appId}
                  />

                  {submissionDetails &&
                    Object.keys(submissionDetails).length > 0 && (
                      <ApplicationDetailsCategory
                        submissionData={submissionDetails}
                        categoryData={categoryData.categories}
                      />
                    )}
                  {submissionDetails &&
                    Object.keys(submissionDetails).length > 0 &&
                    submissionDetails.dsaInfo && (
                      <ApplicationDetailsDSA
                        submissionData={submissionDetails}
                      />
                    )}
                  {submissionDetails &&
                    Object.keys(submissionDetails).length > 0 &&
                    sessionStorage.getItem("idpLogin") === "true" && (
                      <ApplicationDetailsLegalDocuments />
                    )}
                  {submissionDetails &&
                  Object.keys(submissionDetails).length > 0 ? (
                    <DomainApproverApplicationDetailsTargeting
                      targettingData={submissionDetails}
                      appData={appData}
                      appId={appId}
                    />
                  ) : (
                    <div>No data found.</div>
                  )}
                  <ApplicationDetailsRollout
                    postCallTheNewSubmissionGlobalAdmin={
                      postCallTheNewSubmissionGlobalAdmin
                    }
                  />
                  {submissionDetails &&
                    Object.keys(submissionDetails).length > 0 &&
                    submissionDetails.isMonetized &&
                    (submissionDetails.isInAppPurchase ||
                      submissionDetails.isPremiumApp) && (
                      <GlobalAdminMonetize />
                    )}
                </div>
              </div>
            </div>
          </Grid2>
        </Container>
      )}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box className="qaReportPopUp" sx={{ width: "900px", height: "444px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "10px",
            }}
          >
            <Typography
              id="modal-modal-title"
              fontSize={"22px"}
              fontWeight={"600"}
              marginLeft={"18px"}
            >
              All Reports
            </Typography>
            <button style={{ cursor: "pointer", background: "none", border: "none", padding: 0 }} onClick={handleClose}>
              <IconButton component="span">
                <CloseIcon />
              </IconButton>
            </button>
          </div>
          <div
            className="qaReports-popup-section"
            style={{ height: "360px", overflowY: "auto" }}
          >
            {submissionDetails?.reports && (
              <ApplicationQaReportsPopUp
                qaReports={submissionDetails.reports}
                openAddReportPopup={openAddReportPopup}
                setOpenAddReportPopup={setOpenAddReportPopup}
              />
            )}
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default GlobalAdminApplicationDetails;
